import React, { useEffect, useState } from "react";
// import Data from "../../dummy";
// import JobList from "./JobList";
import * as paths from "../../../constants/paths";

import {
  fetchJobs,
  searchJobsData,
  saveJobAction,
  applyJob,
  reportAnJob,
  reportAnJobPopup,
} from "../../../states/actions/fetchJobs";
import { useSelector, useDispatch } from "react-redux";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import LoadingScreen from "../../common/LoadingScreen";
import { ToastContainer } from "react-toastify";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import FindSearch from "./FindSearch";
import JobBlock from "./JobBlock";
import JobApplyPopup from "../../common/JobApplyPopup";
import ReactPaginate from "react-paginate";

const FindJobs = () => {
  const [showSigninPopup, setShowSigninPopup] = useState(false);
  const navigate = useNavigate();
  const { page } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const data = useSelector((state) => state.fetchJobs.content);
  //   console.log('data',data);

  const isLoading = useSelector((state) => state.fetchJobs.isLoading);
  const isSearching = useSelector((state) => state.fetchJobs.isSearching);
  const isJobSaving = useSelector((state) => state.fetchJobs.isJobSaving);
  const isJobApplying = useSelector((state) => state.fetchJobs.isJobApplying);
  const isJobReporting = useSelector((state) => state.fetchJobs.isJobReporting);

  const [pageNo, setPageNo] = useState(page);
  const [pageCount, setPageCount] = useState(0);
  let itemsPerPage = 15;
  const initialPage = pageNo - 1;

  const [showApplyPopup, setShowApplyPopup] = useState(false);
  const [popupJob, setPopupJob] = useState(null);
  const [openTooltipJobId, setOpenTooltipJobId] = useState(null);
  const isSiteSettingsLoading = useSelector(
    (state) => state.fetchSiteSettings.isLoading
  );
  const showReportPopup = useSelector(
    (state) => state.fetchJobs.showReportPopup
  );

  const jobs = useSelector((state) => state.fetchJobs.jobs);
  const totalJobs = useSelector((state) => state.fetchJobs.totalJobs);
  const plan = useSelector((state) => state.fetchSiteSettings.plan);
  const memData = useSelector((state) => state.fetchSiteSettings.memData);

  const {
    content,
    cities,
    cats,
    types,
    degree_req,
    industries,
    meta_desc,
    site_settings,
  } = data;

  const reqParams = new URLSearchParams(location.search);
  const is_global_val = reqParams.get("is_global")
    ? reqParams.get("is_global")
    : reqParams.get("global") &&
      (reqParams.get("global") === true || reqParams.get("global") === "true")
    ? 1
    : "";
  useEffect(() => {
    if (location.search) {
      const queryParams = new URLSearchParams(location.search);
      const filters = {
        searchKeyword: queryParams.get("search") || "",
        jobCats: queryParams.get("jobCats")
          ? queryParams.get("jobCats").split(",")
          : [],
        cities: queryParams.get("cities")
          ? queryParams.get("cities").split(",")
          : [],
        types: queryParams.get("types")
          ? queryParams.get("types").split(",")
          : [],
        jobRequirements: queryParams.get("jobRequirements")
          ? queryParams.get("jobRequirements").split(",")
          : [],
        visaAcceptance: queryParams.get("visaAcceptance") === "true",
        applicants_outside_uk:
          queryParams.get("applicants_outside_uk") === "true",
      };
      // dispatch(fetchJobs());
      // dispatch(searchJobsData(filters));
    }
  }, [location?.search]);

  useEffect(() => {
    dispatch(fetchJobs({ is_global_val: is_global_val }));
  }, []);

  const isAlreadyInBasePath =
    typeof window !== "undefined" &&
    window.location.pathname.includes(`${paths.SITE_BASE_URL}`);
  const basePath = isAlreadyInBasePath ? "" : `${paths.SITE_BASE_URL}`;
  useEffect(() => {
    // console.log("is_global_val", is_global_val);
    if (parseInt(is_global_val) == 1 && memData?.mem_email) {
      if (plan?.id && ![5, 6, 7, 8].includes(parseInt(plan?.id))) {
        // console.log("matched");
        navigate(basePath + "/subscription");
      }
      if (plan?.id === undefined || !plan || plan === null) {
        navigate(basePath + "/subscription");
      }
      // console.log(
      //   plan,
      //   "plan",
      //   plan?.id && ![5, 6, 7, 8].includes(parseInt(plan?.id))
      // );
    }
  }, [is_global_val, plan, memData]);

  const searchJobs = (filters) => {
    const queryParams = new URLSearchParams();

    for (const key in filters) {
      const value = filters[key];
      // Check if the value is not null, undefined, an empty string, or an empty array
      if (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        !(Array.isArray(value) && value.length === 0) &&
        value !== "null" // Additional check for string "null"
      ) {
        queryParams.append(key, Array.isArray(value) ? value.join(",") : value);
      }
    }

    navigate(`/find-jobs/${page}?${queryParams.toString()}`);
    dispatch(searchJobsData(filters));
  };

  const saveJob = (formData) => {
    dispatch(saveJobAction(formData));
  };

  const handleReportAnJob = (formData) => {
    dispatch(reportAnJob(formData));
  };

  const handleShowSigninPopup = () => {
    setShowSigninPopup(!showSigninPopup);
  };

  const handleToggleReportPopup = () => {
    dispatch(reportAnJobPopup());
  };

  const dismissPopup = () => {
    setShowApplyPopup(false);
    setPopupJob(null);
  };

  const handleJobApply = (id) => {
    dispatch(applyJob({ id }));
  };

  const handleTitleClick = (job) => {
    if (job.is_internal_or_external === "external") {
      if (isJobSaving) {
        return false;
      }
      setShowApplyPopup(true);
      setPopupJob(job);
      window.open(job.job_link, "_blank");
    } else {
      navigate(`/job-profile/${job.id}`);
    }
  };

  useEffect(() => {
    // const endOffset = itemOffset + itemsPerPage;
    // setCurrentItems(jobs.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(totalJobs / itemsPerPage));
  }, [totalJobs]);

  const handlePageClick = (event) => {
    // console.log(event.selected);
    window.scrollTo({ top: 300, behavior: "smooth" });
    let pageNumber = event.selected + 1;
    const isAlreadyInBasePath =
      typeof window !== "undefined" &&
      window.location.pathname.includes(`${paths.SITE_BASE_URL}`);
    const basePath = isAlreadyInBasePath ? "" : `${paths.SITE_BASE_URL}`;
    if (pageNumber > 2) {
      if (!plan) {
        navigate(basePath + "/subscription");
        // window.location.replace("/subscription");
        return false;
      } else {
        setPageNo(event.selected + 1);
        navigate(`${basePath}/find-jobs/${event.selected + 1}`);
        // const newOffset = (event.selected * itemsPerPage) % jobs.length;
        // setItemOffset(newOffset);
      }
    } else {
      setPageNo(event.selected + 1);
      navigate(`${basePath}/find-jobs/${event.selected + 1}`);
      // const newOffset = (event.selected * itemsPerPage) % jobs.length;
      // setItemOffset(newOffset);
    }
  };

  useDocumentTitle(data.page_title);

  return (
    <>
      {isLoading || isSiteSettingsLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <ToastContainer />
          <section id="find_jobs">
            <div className="contain">
              <div className="top_text">
                <h2>Find Your Dream Job</h2>
                <p>Discover opportunities from top companies worldwide</p>
              </div>
              <FindSearch
                data={data.content}
                jobs={jobs}
                cities={cities}
                cats={cats}
                types={types}
                degree_req={degree_req}
                industries={industries}
                searchJobs={searchJobs}
                isSearching={isSearching}
                saveJob={saveJob}
                isJobSaving={isJobSaving}
                isJobReporting={isJobReporting}
                handleReportAnJob={handleReportAnJob}
                handleShowSigninPopup={handleShowSigninPopup}
                showSigninPopup={showSigninPopup}
                showReportPopup={showReportPopup}
                handleToggleReportPopup={handleToggleReportPopup}
                totalJobs={totalJobs}
                is_global_val={is_global_val}
                pageNo={pageNo}
                setPageNo={setPageNo}
              />
              {/* <div className="top_head">
                <div className="text">
                  <h3>{totalJobs} Jobs Found</h3>
                  <p>Based on your search criteria</p>
                </div>
                <div className="sort">
                  Sort by:
                  <select name="" id="" className="input">
                    <option value="">Most Recent</option>
                    <option value="">Least Recent</option>
                   
                  </select>
                </div>
              </div> */}
              <div className="flex_row job_row row">
                {isSearching ? (
                  <div className="col">Fetching...</div>
                ) : jobs && jobs.length === 0 ? (
                  <div className="msg_no_jobs">
                    No jobs match your search right now. We update listings
                    daily. Set up a <Link to="/job-alerts">job alert</Link> and
                    we'll email you when a matching role is posted.
                  </div>
                ) : (
                  jobs &&
                  jobs.map((job) => {
                    return (
                      <div className="col" key={job.id}>
                        <JobBlock
                          data={data}
                          job={job}
                          saveJob={saveJob}
                          isJobSaving={isJobSaving}
                          handleJobApplyPopup={handleTitleClick}
                          handleShowSigninPopup={handleShowSigninPopup}
                          showSigninPopup={showSigninPopup}
                          openTooltipJobId={openTooltipJobId}
                          setOpenTooltipJobId={setOpenTooltipJobId}
                          is_global_val={is_global_val}
                        />
                      </div>
                    );
                  })
                )}
              </div>
              {/* {jobs.map((job) => (
                <JobBlock key={job.id} {...job} />
              ))} */}

              <ReactPaginate
                forcePage={initialPage}
                pageCount={pageCount}
                onPageChange={handlePageClick}
                breakLabel="..."
                previousLabel=""
                nextLabel=""
                pageRangeDisplayed={4}
                marginPagesDisplayed={1}
                containerClassName="pagination"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                activeClassName="active"
                previousClassName="prev_btn"
                previousLinkClassName="page-link"
                nextClassName="next_btn"
                nextLinkClassName="page-link"
                breakClassName=""
                breakLinkClassName="page-link"
                renderOnZeroPageCount={false}
              />
            </div>
          </section>
          {showApplyPopup && (
            <JobApplyPopup
              job={popupJob}
              dismissPopup={dismissPopup}
              handleJobApply={handleJobApply}
              isJobApplying={isJobApplying}
              saveJob={saveJob}
              isJobSaving={isJobSaving}
              isJobReporting={isJobReporting}
              handleReportAnJob={handleReportAnJob}
              handleShowSigninPopup={handleShowSigninPopup}
              showSigninPopup={showSigninPopup}
              showReportPopup={showReportPopup}
              handleToggleReportPopup={handleToggleReportPopup}
            />
          )}
        </>
      )}
    </>
  );
};

export default FindJobs;
